<h2 mat-dialog-title style="margin: 0px;">Mitarbeiter auswählen</h2>
<mat-dialog-content>
  <button mat-flat-button color="primary" *ngFor="let user of glo.activeUsers;" (click)="selectMitarbeiter(user)"
          style="margin-bottom: 10px; width: 100%">{{user.name}}
  </button></mat-dialog-content>
<mat-dialog-actions >
  <button mat-button mat-dialog-close tabindex="-1">Abbrechen</button>
</mat-dialog-actions>
